import { Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { takeWhile } from 'rxjs/operators';
import { AppState } from 'src/app/models/app-state';
import { SearchAgain } from 'src/app/state/search/search.actions';
import { selectCanSearchAgain } from 'src/app/state/search/search.selectors';

@Component({
    imports: [AngularSvgIconModule],
    selector: 'rdx-search-this-area-button',
    standalone: true,
    styleUrls: ['./search-this-area-button.component.scss'],
    templateUrl: './search-this-area-button.component.html',
})
export class SearchThisAreaButtonComponent implements OnDestroy, OnInit {
    shouldShowSearchAgainButton = false;

    private isDestroyed = false;

    constructor(private store: Store<AppState>) {}

    ngOnInit(): void {
        this.store
            .select(selectCanSearchAgain)
            .pipe(
                takeWhile(() => {
                    return !this.isDestroyed;
                })
            )
            .subscribe((canSearchAgain) => {
                this.shouldShowSearchAgainButton = canSearchAgain;
            });
    }

    ngOnDestroy(): void {
        this.isDestroyed = true;
    }

    searchAgain() {
        this.store.dispatch(SearchAgain({ searchAgain: true }));
    }
}
